<app-filter-debtor-favorite
    (geFilter)="receiveFilterGeneral($event)"
></app-filter-debtor-favorite>

<main>
    <app-table-debtor-favorite
        [recieveFilterName]="deudores"
        [booleanFlag]="booleanFlag"
        [booleanText]="booleanText"
        (changePagination)="receiveProviderPaginationChange($event)"
        (changeSorting)="receiveChangeSortingOrder($event)"
        (actualizarData)="actualizarData($event)"
    ></app-table-debtor-favorite>
</main>
